function serializeAsBag(value: any): string {
	if (!Array.isArray(value)) {
		return `<rdf:li>${String(value)}</rdf:li>`
	}
	const items = value
		.map((v) => {
			if (Array.isArray(v)) {
				return `<rdf:Bag>${serializeAsBag(v)}</rdf:Bag>`
			} else {
				return `<rdf:li>${String(v)}</rdf:li>`
			}
		})
		.join("")

	return `<rdf:Bag xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">${items}</rdf:Bag>`
}

function buildArrayElement(tagName: string, arr: any[]): string {
	return `<${tagName}>${serializeAsBag(arr)}</${tagName}>`
}

export function makeXMP(metadata: { [key: string]: any }): ArrayBuffer {
	const defaultPrefix = "pn"
	const namespaceMap: Record<string, string> = {
		pn: "https://next.polarr.com/app/ns/schema",
		xmp: "http://ns.adobe.com/xap/1.0/",
		xmpDM: "http://ns.adobe.com/xmp/1.0/DynamicMedia/",
		tiff: "http://ns.adobe.com/tiff/1.0/",
		exif: "http://ns.adobe.com/exif/1.0/",
		aux: "http://ns.adobe.com/exif/1.0/aux/",
		lr: "http://ns.adobe.com/lightroom/1.0/",
	}
	const usedPrefixes = new Set<string>()

	const attrs: string[] = []
	const inner: string[] = []

	const getQualifiedName = (key: string) => {
		const splitIndex = key.indexOf(":")
		if (splitIndex > 0) {
			const prefix = key.slice(0, splitIndex)
			const localName = key.slice(splitIndex + 1)
			if (namespaceMap[prefix]) {
				usedPrefixes.add(prefix)
				return `${prefix}:${localName}`
			}

			// Unknown prefix: fall back to default prefix and strip extra colons to keep XML valid.
			usedPrefixes.add(defaultPrefix)
			return `${defaultPrefix}:${localName.replace(/:/g, "_")}`
		}

		usedPrefixes.add(defaultPrefix)
		return `${defaultPrefix}:${key}`
	}

	for (const [k, v] of Object.entries(metadata)) {
		const name = getQualifiedName(k)
		if (v === null || v === undefined) continue

		if (Array.isArray(v)) {
			inner.push(buildArrayElement(name, v))
		} else if (typeof v === "object") {
			attrs.push(`${name}="${JSON.stringify(v)}"`)
		} else {
			attrs.push(`${name}="${String(v)}"`)
		}
	}

	const rdfDescription = `
    <rdf:Description rdf:about="" ${attrs.join(" ")}>
    ${inner.join("\n  ")}
    </rdf:Description>`.trim()

	const namespaceAttrs = Array.from(usedPrefixes)
		.sort()
		.map((prefix) => `xmlns:${prefix}="${namespaceMap[prefix]}"`)
		.join(" ")

	const rdf = `
    <x:xmpmeta xmlns:x="adobe:ns:meta/">
    <rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
            ${namespaceAttrs}>
        ${rdfDescription}
    </rdf:RDF>
    </x:xmpmeta>`.trim()

	const packet = `<?xpacket begin="\uFEFF" id="pixieset-pn-adjustments"?>\n${rdf}\n<?xpacket end="w"?>`

	const encoder = new TextEncoder()
	const xmpBody = encoder.encode(packet)

	const signature = encoder.encode("http://ns.adobe.com/xap/1.0/\0")
	const out = new Uint8Array(signature.byteLength + xmpBody.byteLength)

	out.set(signature, 0)
	out.set(xmpBody, signature.byteLength)

	return out.buffer
}
